var utils = {
    getID: function() {
        return sessionStorage.getItem("p");
    },

    getEncrypt: function() {
        return sessionStorage.getItem("q")==='Y';
    },

    pieProtectSPI: function(datatoEncrypt) {
        var delimiter=" ";
        try{
            var result = window.ProtectString(datatoEncrypt);
            if(result != null) {
                datatoEncrypt=result[0];
                datatoEncrypt=datatoEncrypt+delimiter+PIE.key_id+delimiter+PIE.phase+delimiter+"PSS";
            }
        } catch(e) {}

        return datatoEncrypt;
    },

    pieProtectPCI: function(cardInfo, cvv2) {
        var datatoEncrypt=null;
        var delimiter=" ";
        try{
            // check Luhn digit, since PIE encryption assumes valid checksum
            if(!window.ValidatePANChecksum(cardInfo)) {
                window.alert("Card number has invalid checksum");
            }
            // perform PIE encryption, and set results in hidden form fields for submission
            var result = window.ProtectPANandCVV(cardInfo, cvv2);

            if(result != null) {
                datatoEncrypt=result[0]+delimiter+result[1]+delimiter+"PCC";
                result[0]=datatoEncrypt;
            }

        } catch(e) {}
        return result;
    },

    getSendPrefix: function() {
        return 'MOB|';
    },

    getReceivePrefix: function() {
        return 'POS|';
    },

    getUrl: function(url) {
        var baseUrl = '/inspicio/',
            urlMap = {
                agreementService: 'fetchAgreement',
                loggingService: 'reportError'
            }

        return baseUrl + urlMap[url];
    },

    getMsgUrl: function(url) {
        var baseUrl = '/inspicio/',
            urlMap = {
                receiveService: 'receive',
                sendService: 'send'
            }

        return baseUrl + urlMap[url];
    },

    unescapeHTML: function(html) {
        var e = document.createElement('div');
        e.innerHTML = html;
        return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    },

    debounce: function(func, wait, immediate) {
        var timeout, result;
        return function() {
            var context = this,
                args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) result = func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) result = func.apply(context, args);
            return result;
        };
    },

    defer: function(func, time) {
        setTimeout(func, time ? time : 1);
    }
};

export default utils;



// WEBPACK FOOTER //
// ./src/js/utils/utils.js